import classNames from 'classnames';
import { IVisibleLobbyPlayer } from '../../../Models/LobbyModels';
import Avatar, { BotIcon } from '../Avatar/Avatar';
import { SectionHeading } from '../StartScreen/StartScreen';
import { SETTINGS_LIST_CLASS_NAME, Stepper } from './LobbyControls';

interface ILobbyPlayersProps {
  players: IVisibleLobbyPlayer[];
  idHash: string | undefined;
  numberOfBots: number;
  onBotsChange?: (numberOfBots: number) => void;
}

const ROW_CLASS_NAME = 'flex h-[56px] items-center gap-[12px] px-[14px]';

const TAG_CLASS_NAME =
  'shrink-0 rounded-full px-[8px] py-[2px] text-[11px] font-bold';

export default function LobbyPlayers({
  players,
  idHash,
  numberOfBots,
  onBotsChange,
}: ILobbyPlayersProps) {
  const showBots = !!onBotsChange || numberOfBots > 0;
  return (
    <section
      aria-labelledby="lobby-players"
      className="flex flex-col gap-[8px]"
    >
      <SectionHeading id="lobby-players" count={players.length + numberOfBots}>
        Players
      </SectionHeading>
      <ul className={SETTINGS_LIST_CLASS_NAME}>
        {players.map((player, i) => (
          <li key={player.idHash} className={ROW_CLASS_NAME}>
            <Avatar
              name={player.name}
              colorIndex={i}
              className={classNames('size-[32px] text-[14px]', {
                'opacity-40': !player.connected,
              })}
            />
            <span className="min-w-0 truncate text-[15px] font-semibold">
              {player.name}
            </span>
            {player.idHash === idHash && (
              <span
                className={classNames(
                  TAG_CLASS_NAME,
                  'bg-control text-ink-muted'
                )}
              >
                You
              </span>
            )}
            {!player.connected && (
              <span className="ml-auto shrink-0 text-[12px] font-medium text-ink-muted">
                Offline
              </span>
            )}
          </li>
        ))}
        {showBots && (
          <li className={ROW_CLASS_NAME}>
            <span
              aria-hidden="true"
              className="flex size-[32px] shrink-0 items-center justify-center rounded-full bg-control text-ink-muted"
            >
              <BotIcon />
            </span>
            <span className="min-w-0 flex-1 truncate text-[15px] font-semibold">
              Bots
            </span>
            <Stepper
              label="bots"
              value={numberOfBots}
              onChange={onBotsChange}
            />
          </li>
        )}
      </ul>
    </section>
  );
}
